/* ================================================== */
/* COMPONENTS → Production
/* ================================================== */

$(document).ready(function() {

	// Add class on scroll
	var $blockProduction = $('.blocks__production');
	$(window).on('scroll', function() {
		$.each($blockProduction, function(index, el) {
			if ($(el).isInViewport()) {
				$('.production__status', el).addClass('visible');
			}
		});
	});

	// Remove class on filter change
	$('.header__productions a, .blocks__dropdown a').click(function() {
		$('.production__status').removeClass('visible');
	});

});